import React from "react";
import { Compass, BookOpenCheck, GitCompareArrows, Wallet } from "lucide-react";
import { Reveal } from "../Reveal";

const STEPS = [
  { n: "01", icon: Compass, title: "Discover", text: "Find businesses worth researching." },
  { n: "02", icon: BookOpenCheck, title: "Understand", text: "Explore the Company Intelligence page." },
  { n: "03", icon: GitCompareArrows, title: "Compare", text: "Put businesses head-to-head." },
  { n: "04", icon: Wallet, title: "Track", text: "Add companies to your Portfolio Simulator." },
];

// A subtle, editorial explanation of the LONGVIEW research workflow —
// reinforces the ecosystem without adding any new data dependency.
export const ResearchPath = () => (
  <Reveal>
    <div data-testid="discover-research-path" className="border-t border-white/[0.07] pt-8">
      <div className="kicker mb-2 text-amber-400">The LONGVIEW Workflow</div>
      <h2 className="mb-6 text-xl font-bold text-white sm:text-2xl">From discovery to understanding.</h2>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 60}>
            <div>
              <div className="flex items-center gap-2.5">
                <span className="font-mono text-xs text-zinc-600">{s.n}</span>
                <span className="flex h-8 w-8 items-center justify-center rounded-md border border-white/10 bg-[#0B0C0E]"><s.icon className="h-4 w-4 text-amber-400" /></span>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-white">{s.title}</h3>
              <p className="mt-1 text-xs leading-relaxed text-zinc-500">{s.text}</p>
              {i < STEPS.length - 1 && <div className="mt-4 hidden h-px w-full bg-gradient-to-r from-white/10 to-transparent lg:block" />}
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </Reveal>
);
